/** @jsx jsx */
import React from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { jsx } from 'theme-ui';
import {
  NavigationCollapse as collapseStyles,
  NavbarToggle as toggleStyles,
  Nav as navStyles,
} from '../Header.styles';

export default function HeaderNavigation({
  items = [],
  id = 'mainNav',
  children,
  hideToggle,
  ...props
}) {
  return (
    <React.Fragment>
      {!hideToggle && <Navbar.Toggle sx={toggleStyles} aria-controls={id} />}
      <Navbar.Collapse className={id} sx={collapseStyles}>
        <Nav sx={navStyles} {...props}>
          {children}
        </Nav>
      </Navbar.Collapse>
    </React.Fragment>
  );
}
